import RequestPushNotificationsPermitAlert from './RequestPushNotificationsPermitAlert';
import RequestAppReviewAlert from './RequestAppReviewAlert';

export default {
  RequestPushNotificationsPermitAlert,
  RequestAppReviewAlert,
};
